import type { SVGProps } from 'react';

const SvgVideoHighlight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11 17H6c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3c0 .55.45 1 1 1s1-.45 1-1V8c0-1.65-1.35-3-3-3H6C4.35 5 3 6.35 3 8v8c0 1.65 1.35 3 3 3h5c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M10.94 9.12c-.61-.35-1.38.09-1.38.79v4.16c0 .71.76 1.15 1.38.79l3.6-2.08a.92.92 0 0 0 0-1.59l-3.6-2.08zm11.04 7.12a.43.43 0 0 0-.36-.3l-2.23-.32-1-2.02c-.15-.3-.65-.3-.8 0l-1 2.02-2.23.32c-.17.02-.31.14-.36.3s0 .34.11.46l1.61 1.57-.38 2.22c-.03.17.04.34.18.43.14.1.32.11.47.03l1.99-1.05 1.99 1.05c.06.03.14.05.21.05.09 0 .18-.03.26-.08.14-.1.21-.27.18-.43l-.38-2.22 1.61-1.57c.12-.12.16-.29.11-.46z"
    />
  </svg>
);
export default SvgVideoHighlight;
